import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PreviewSection = ({ title, rows }) => (
    <Box sx={{ mb: 2.5 }}>
        <Typography
            variant="subtitle2"
            sx={{
                color: '#28326f',
                fontWeight: 600,
                mb: 1.5,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                fontSize: '0.75rem',
            }}
        >
            {title}
        </Typography>
        <Box
            sx={{
                border: '1px solid #e8ecf4',
                borderRadius: '10px',
                overflow: 'hidden',
                backgroundColor: '#fafbfd',
            }}
        >
            {rows.map((row, index) => (
                <Box
                    key={row.label}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: '180px 1fr' },
                        gap: { xs: 0.5, sm: 2 },
                        px: 2,
                        py: 1.5,
                        borderBottom: index < rows.length - 1 ? '1px solid #eef1f7' : 'none',
                        backgroundColor: '#fff',
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{ color: '#6b7280', fontWeight: 500 }}
                    >
                        {row.label}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ color: '#1f2937', fontWeight: 500, wordBreak: 'break-word' }}
                    >
                        {row.value || '-'}
                    </Typography>
                </Box>
            ))}
        </Box>
    </Box>
);

const AddAuthorityPreview = ({
    showPreview,
    setShowPreview,
    formData,
    handleSubmit,
    stateName,
    districtName,
}) => {
    const handleClose = () => setShowPreview(false);

    const contactRows = [
        { label: 'Name', value: formData.name },
        { label: 'Email', value: formData.email },
        { label: 'Mobile', value: formData.mobile },
    ];

    const addressRows = [
        { label: 'State', value: stateName },
        { label: 'District', value: districtName },
        { label: 'Pincode', value: formData.pincode },
        { label: 'Address', value: formData.address },
    ];

    const bankRows = [
        { label: 'Bank Name', value: formData.bank_name },
        { label: 'Branch', value: formData.branch },
        { label: 'Account No', value: formData.account_no },
        { label: 'IFSC Code', value: formData.ifsc_code },
    ];

    return (
        <Dialog
            open={showPreview}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: '12px' },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pb: 1,
                    color: '#28326f',
                    fontWeight: 600,
                }}
            >
                Review Authority Details
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    size="small"
                    sx={{ color: '#6b7280' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ pt: 2.5, pb: 1 }}>
                <Typography
                    variant="body2"
                    sx={{ color: '#6b7280', mb: 2.5 }}
                >
                    Please verify the information below before submitting.
                </Typography>

                <PreviewSection title="Contact Information" rows={contactRows} />
                <PreviewSection title="Address Details" rows={addressRows} />
                <PreviewSection title="Bank Details" rows={bankRows} />
            </DialogContent>

            <Divider />

            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    sx={{
                        textTransform: 'none',
                        borderColor: '#d1d5db',
                        color: '#374151',
                    }}
                >
                    Change
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        textTransform: 'none',
                        backgroundColor: '#28326f',
                        '&:hover': { backgroundColor: '#1f2659' },
                    }}
                >
                    Confirm & Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddAuthorityPreview;
